import React, { useEffect, useContext } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import { GlobalContext } from '../contexts/GlobalContext';

function Redirector() {
  const { contact, portal } = useContext(GlobalContext);
  let { params } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    params = params && JSON.parse(atob(params));

    if (!params) {  navigate('/', {replace: true}); return; }
    console.log('params: ', params);
    
    if (!checkAccess(params)) { navigate('/', {replace: true}); return;  }
    console.log('access granted');
    
    let urlPath = '/';
    switch (params.type) {
      case 'chat':
        urlPath += 'chat/channel/' + params.chat_channel;
        break;
      case 'ticket':
        urlPath += 'ticket/' + params.ticket_id;
        break;
      case 'invoice':
        urlPath += 'invoice/' + params.invoice_id;
        break;
    }
    console.log('urlPath: ', urlPath);
    console.log('navigating...');
    
    navigate(urlPath, {replace: true});return;
  });

  function checkAccess(params) {
    if (params.portal && params.portal != portal) return false;
    if (params.contact && params.contact != contact) return false;
    return true;
  }

  // TODO: add redirecting animation
  return (
    <div>Redirecting...</div>
  )
}

export default Redirector